import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../../util/guideline'
import { IssuerTier } from '../../models'
import { UpdateIssuerTier } from './UpdateIssueTier'

interface UpdateIssuerTierDrawerProps {
  issuerId: number
  tiers: IssuerTier[]
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateIssuerTierDrawer = ({
  issuerId,
  tiers,
  isVisible,
  onClose,
  onSuccess,
}: UpdateIssuerTierDrawerProps) => {
  return (
    <Drawer
      title="Update Issuer Tier"
      placement="right"
      open={isVisible}
      onClose={onClose}
      width={drawerAndModalWidth}
      destroyOnClose
    >
      <UpdateIssuerTier issuerId={issuerId} tiers={tiers} onSuccess={onSuccess} />
    </Drawer>
  )
}
